import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router';
import settings from '../settings';
import EmailListPage from '../pages/EmailListPage';
import EmailTemplateDetailPage from '../pages/EmailTemplateDetailPage';
import HistoryPage from '../pages/HistoryPage/HistoryPage';
import QAPrivatePage from '../pages/QAPrivatePage';
import SMSHistoryPage from '../pages/SMSHistoryPage';
import SMSListPage from '../pages/SMSListPage';
import SMSTemplateDetailPage from '../pages/SMSTemplateDetailPage';
import Layout from '../shared/layout/Layout';
import TemplateLayout from '../shared/layout/TemplateLayout';
const routes = [
    {
        path: settings.routePrefix || '/',
        element: (_jsx(Layout, { children: _jsx(Outlet, {}) })),
        children: [
            {
                path: 'templates',
                element: (_jsx(TemplateLayout, { children: _jsx(Outlet, {}) })),
                children: [
                    {
                        path: 'emails',
                        element: _jsx(EmailListPage, {}),
                    },
                    {
                        path: 'emails/:id',
                        element: _jsx(EmailTemplateDetailPage, {}),
                    },
                    {
                        index: true,
                        element: _jsx(Navigate, { to: "emails" }),
                    },
                    {
                        path: 'sms',
                        element: _jsx(SMSListPage, {}),
                    },
                    {
                        path: 'sms/:id',
                        element: _jsx(SMSTemplateDetailPage, {}),
                    },
                ],
            },
            {
                path: 'history/email',
                element: _jsx(HistoryPage, {}),
            },
            {
                path: 'history/sms',
                element: _jsx(SMSHistoryPage, {}),
            },
        ],
    },
    {
        path: 'qa-feature-flag',
        element: _jsx(QAPrivatePage, {}),
    },
];
export default routes;
